import { theme } from '../theme';

export const CreateEmployerStyles = () => ({
  dashCtn: {
    color: theme.palette.primary.black,
    padding: '0 48px'
  },
  paper: {
    borderRadius: '6px',
    position: 'relative'
  },
  stepper: {
    position: 'absolute',
    top: '60px',
    left: 'calc(50% - 48px)',
    '& .MuiStepLabel-root': {
      '& .MuiStepIcon-root': {
        text: {
          display: 'none'
        },
        color: theme.button.bgColorGray
      },
      '& .Mui-active': {
        color: theme.palette.secondary.black
      },
      '& .Mui-completed': {
        fill: theme.palette.primary.main,
        color: theme.palette.primary.black,
      }
    }
  },
  ctnInner: {
    padding: '112px 8.5rem',
    height: '100%',
    maxWidth: '100%',
    margin: '0',
    '& h3': {
      fontWeight: '700',
      fontSize: '4rem',
      margin: '20px 0'
    }
  },
  boxCtn: {
    marginTop: '1.5rem',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  boxItem: {
    position: 'relative',
    width: '45%',
    marginBottom: '2.4rem',
    '& > p': {
      fontSize: '1.125rem',
      margin: '0 0 16px',
      display: 'block'
    }
  },
  inputCustom: {
    width: '100%',
    '& .MuiInputLabel-root': { padding: '0 8px' },
    '& .MuiOutlinedInput-root': {
      height: '56px',
      color: theme.palette.secondary.black,
      '&.Mui-focused': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.primary.main,
          borderWidth: '2px'
        }
      },
      '& .MuiOutlinedInput-notchedOutline': {
        border: `1px solid ${theme.palette.primary.black}`
      },
      '& .MuiInputBase-input': { padding: '12px 20px' }
    },
    '& .MuiInputBase-input': {
      display: 'flex',
      alignItems: 'center',
      padding: '12px'
    },
    '& .MuiFormHelperText-root': {
      position: 'absolute',
      bottom: '-14px',
      left: '10px',
      background: theme.palette.primary.white,
      padding: '0 10px',
      fontSize: '0.875rem',
      margin: '0'
    },
    '> .MuiFormLabel-root.Mui-focused': {
      top: '0',
      color: theme.palette.primary.black,
    }
  },
  checkboxCustom: {
    margin: '0px',
    color: theme.palette.secondary.black,
    '&.Mui-checked': {
      color: theme.palette.primary.main,
    },
  },
  select: {
    width: '100%',
    '& .MuiOutlinedInput-input': {
      padding: '16px 20px',
      color: theme.palette.secondary.black,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: `1px solid ${theme.palette.primary.black}`
    }
  },
  selectError: {
    '& .MuiOutlinedInput-notchedOutline': {
      border: `1px solid ${theme.palette.error.mediumError}`,
      '&:hover': {
        border: `1px solid ${theme.palette.error.mediumError}`
      }
    }
  },
  formButtonWrapper: {
    margin: '48px auto 0',
    width: '90%',
    display: 'flex',
    justifyContent: 'space-evenly',
    backgroundColor: theme.button.bgColorGray,
    color: theme.palette.primary.white,
    height: '56px',
    '&:hover': {
      backgroundColor: theme.button.bgColorGray,
      boxShadow: 6
    },
    '& .MuiButton-root': {
      height: '56px',
      width: '45%',
      textTransform: 'none',
      backgroundColor: theme.button.bgColorGray,
      opacity: '0.5',
      color: theme.palette.primary.white,
      fontWeight: '600',
      fontSize: '1.5rem',
      boxShadow: 4,
      '&:hover': {
        backgroundColor: theme.button.bgColorGray,
        boxShadow: 6
      }
    },
    '& .MuiButton-root:last-of-type': {
      height: '56px',
      width: '45%',
      backgroundColor: theme.palette.primary.black,
      opacity: '1',
      color: theme.palette.primary.white,
      '&:hover': {
        boxShadow: 12
      }
    }
  },
  cancelButton: {
    width: '100%',
    marginRight: '10px',
    height: '48px',
    borderRadius: '4px',
    textTransform: 'none',
    backgroundColor: theme.button.bgColorGray,
    color: theme.palette.primary.white,
    fontSize: '1.3rem',
    '&:hover': {
      backgroundColor: theme.button.bgColorGrayHover,
      boxShadow: 'none',
      color: theme.palette.primary.black,
    }
  },
  passwordInput: {
    '& .MuiInputBase-input': {
      position: 'relative'
    },
    '& .MuiFormHelperText-root': {
      position: 'absolute',
      bottom: '-10px',
      fontSize: '12px',
      left: '10px',
      margin: '0px',
      padding: '0 10px',
      backgroundColor: theme.palette.primary.white,
    }
  },
  formCtn: {
    height: 'calc(100% - 4rem)'
  },
  optButton: {
    '& .MuiFormControlLabel-label': {
      fontSize: '16px'
    }
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  stateError: {
    position: 'absolute',
    bottom: '-25px',
    left: '15px',
    background: theme.palette.primary.white,
    color: theme.palette.error.mediumError,
    padding: '0 8px',
    fontSize: '0.875rem !important',
    '&::first-letter': {
      textTransform: 'capitalize'
    }
  },
  stateIDError: {
    position: 'absolute',
    bottom: '-25px',
    left: '15px',
    background: theme.palette.primary.white,
    color: theme.palette.error.mediumError,
    padding: '0 8px',
    fontSize: '0.875rem !important',
    '&::first-letter': {
      textTransform: 'capitalize'
    }
  },
  countyError: {
    position: 'absolute',
    bottom: '-25px',
    left: '15px',
    background: theme.palette.primary.white,
    color: theme.palette.error.mediumError,
    padding: '0 8px',
    fontSize: '0.875rem !important',
    '&::first-letter': {
      textTransform: 'capitalize'
    }
  },
  cityError: {
    position: 'absolute',
    bottom: '-25px',
    left: '15px',
    background: theme.palette.primary.white,
    color: theme.palette.error.mediumError,
    padding: '0 8px',
    fontSize: '0.875rem !important',
    '&::first-letter': {
      textTransform: 'capitalize'
    }
  },
  showPassword: {
    position: 'absolute',
    right: '16px',
    top: '7px'
  },
  dialog: {
    maxWidth: 'sm',
    title: {
      fontSize: '2rem',
      fontWeight: '700',
      color: theme.palette.primary.black,
    },
    content: {
      fontSize: '1.5rem',
      color: theme.palette.primary.black,
    },
    dialogBox: {
      '& .MuiDialog-paper': {
        padding: '48px'
      }
    },
    cancelButton: 'rgba(36, 35, 35, 0.5)',
    ctaButton: theme.palette.primary.black,
    showButton: 'none'
  },
  formEmployerContainerCheckbox:{
    marginTop: '0px',
  },
  checkbox: {
    display: 'flex',
    justifyContent: 'start',
    margin: '0px',
    padding: 0,
    gap: '10px',
    width: { md: '320px', xs: '100%' }
  },
  btnAddEmail: {
    fontSize: '14px',
    color: theme.palette.primary.main,
    height: '56px',
    display: 'flex',
    padding: '10px',
    textTransform: 'none',
    borderRadius: '5px',
    borderColor: theme.palette.primary.white,
    fontWeight: 'normal',
    '&:hover':{
      backgroundColor: theme.palette.primary.white,
      borderColor: theme.palette.primary.white,
      boxShadow: 4,
    } 
  }
});
